
import { Record } from "../../../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, option_type, decimal_type, string_type, lambda_type, unit_type, class_type } from "../../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { ChallengeResponse_$reflection } from "../../Shared.js";
import { ClientTypes_Msg_$reflection, ClientTypes_Model_$reflection } from "../../ClientTypes.js";
import { CompletenessChecklist_RowState_$reflection } from "../HeroHelpers.js";
import { view as view_1 } from "./PlannedHero.js";
import { view as view_2 } from "./PublishedPledgedHero.js";
import { view as view_3 } from "./ActiveHero.js";
import { view as view_4 } from "./FinalizingHero.js";
import { view as view_5 } from "./FinalizedHero.js";
import { view as view_6 } from "./AbandonedHero.js";
import { HtmlHelper_createElement } from "../../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.5.3.0/String.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.3.0/List.js";
import { content } from "../ChallengeShare.js";
import { tw } from "../../TailwindExtensions.js";
import { flexShrink_flexShrink0, gap_gap$002D2, display_flex } from "../../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { view as view_7 } from "../../Share/QrCodeButton.js";
import { view as view_8 } from "../../Share/ShareButton.js";

/**
 * Inputs the dispatcher needs to route to any hero. Some are unused by Planned (e.g. clock
 * for Pledged/Active KPIs) but still threaded for uniformity.
 */
export class Inputs extends Record {
    constructor(Clock, Challenge, Model, Dispatch, PaymentFormView, TargetAmount, TargetError, OnTargetChange, TargetStatus, CompletenessRow) {
        super();
        this.Clock = Clock;
        this.Challenge = Challenge;
        this.Model = Model;
        this.Dispatch = Dispatch;
        this.PaymentFormView = PaymentFormView;
        this.TargetAmount = TargetAmount;
        this.TargetError = TargetError;
        this.OnTargetChange = OnTargetChange;
        this.TargetStatus = TargetStatus;
        this.CompletenessRow = CompletenessRow;
    }
}

export function Inputs_$reflection() {
    return record_type("Shared.Hero.ChallengeHero.Inputs", [], Inputs, () => [["Clock", class_type("Shared.IClock")], ["Challenge", ChallengeResponse_$reflection()], ["Model", ClientTypes_Model_$reflection()], ["Dispatch", lambda_type(ClientTypes_Msg_$reflection(), unit_type)], ["PaymentFormView", lambda_type(string_type, lambda_type(lambda_type(ClientTypes_Msg_$reflection(), unit_type), class_type("Fable.React.ReactElement", undefined)))], ["TargetAmount", decimal_type], ["TargetError", option_type(string_type)], ["OnTargetChange", lambda_type(decimal_type, unit_type)], ["TargetStatus", class_type("Fable.React.ReactElement", undefined)], ["CompletenessRow", CompletenessChecklist_RowState_$reflection()]]);
}

function dispatchHero(inputs) {
    const matchValue = inputs.Challenge.Status;
    switch (matchValue) {
        case "draft":
        case "planned":
            return view_1(inputs.Challenge, inputs.Model, inputs.CompletenessRow, inputs.PaymentFormView, inputs.Dispatch);
        case "published":
        case "pledged":
            return view_2(inputs.Clock, inputs.Challenge, inputs.TargetAmount, inputs.TargetError, inputs.OnTargetChange, inputs.TargetStatus, inputs.Dispatch);
        case "active":
            return view_3(inputs.Clock, inputs.Challenge, inputs.TargetAmount, inputs.TargetError, inputs.OnTargetChange, inputs.TargetStatus, inputs.Dispatch);
        case "finalizing":
            return view_4(inputs.Clock, inputs.Challenge);
        case "finalized":
            return view_5(inputs.Challenge);
        case "abandoned":
            return view_6(inputs.Challenge);
        default:
            return HtmlHelper_createElement("div", singleton(["children", singleton(toText(printf("Unknown challenge status: %s"))(matchValue))]));
    }
}

/**
 * The lifecycle hero, with QR code and Share buttons pinned top-right when the challenge is shareable.
 */
export function view(inputs) {
    const hero = dispatchHero(inputs);
    if (content(inputs.Challenge) != null) {
        return HtmlHelper_createElement("div", ofArray([["className", "relative [&>div>h3:first-child]:pr-44 [&>div>h3:first-child+p]:pr-44"], ["children", [hero, HtmlHelper_createElement("div", ofArray([["className", "absolute top-0 right-0"], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, gap_gap$002D2, flexShrink_flexShrink0]))], ["children", [view_7(inputs.Challenge), view_8("Share", inputs.Challenge)]]]))]]]))]]]));
    }
    else {
        return hero;
    }
}

//# sourceMappingURL=ChallengeHero.js.map
